import React, { useContext, useEffect, useState } from "react";
import image from "../assets/images/bear.svg";
import styles from "../styles/LiveCard.module.css";

import TradathonContext from "../context/tradathon/TradathonContext";
import Countdown from "react-countdown";
import { withRouter } from "react-router-dom";
import Badge from "./Badge";
import { BiShareAlt } from "react-icons/bi";
import parameterContext from "../context/parameter/parameterContext";
import PublicContestModal from "./PublicContestModal";

import CalculatePrize from "../helpers/CalculatePrize"
const LiveCard = ({
  noOfPlayers,
  startTime,
  entryFees,
  prize,
  rtype,
  rname,
  joinedMembers,
  isFlexible,
  history,
  endTime,
  rstatus,
  rcode,
  isPaid,
  rid,
  winnings,
  activeModalId,
}) => {
  const { tradathonLoading, checkUserJoined, joinedRoom,joiningLoading } =
    useContext(TradathonContext);
  const { listingTab, setTradathonListingTab } = useContext(parameterContext);
  const [openModal, setOpenModal] = useState(false);
  const [dataForModal, setDataForModal] = useState({
    noOfPlayers,
    startTime,
    entryFees,
    prize,
    rtype,
    rname,
    joinedMembers,
    isFlexible,
    history,
    endTime,
    rstatus,
    rcode,
    isPaid,
    rid,
  });

  const renderer = ({ completed, formatted }) => {
    let { days, hours, minutes, seconds } = formatted;

    if (completed) {
      // Render a completed state
      return <span>Contest Started</span>;
    } else {
      // Render a countdown
      let bool = false;
      if (days === "00" && hours === "00" && minutes === "00") {
        bool = true;
      }
      return (
        <>
          {rstatus === 0 ? (
            <p style={{ margin: "5px 0" }}>Starts In</p>
          ) : rstatus === 1 ? (
            <p style={{ margin: "5px 0" }}>Ends In</p>
          ) : (
            <></>
          )}
          <p className="timer" style={{ fontSize: "12px", padding: "2px" }}>
            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : rstatus === 1 && "#45AA43",
                }}
              >
                {days}
              </span>
              <span className="timeLabel">days</span>
            </span>

            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : rstatus === 1 && "#45AA43",
                }}
              >
                {hours}
              </span>
              <span className="timeLabel">hours</span>
            </span>

            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : rstatus === 1 && "#45AA43",
                }}
              >
                {minutes}
              </span>
              <span className="timeLabel">minutes</span>
            </span>

            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : rstatus === 1 && "#45AA43",
                }}
              >
                {seconds}
              </span>
              <span className="timeLabel">seconds</span>
            </span>
          </p>
        </>
      );
    }
  };

  const closeModal = () => {
    setOpenModal(!openModal);
  };
  useEffect(() => {
    if (openModal) {
    }
  }, [openModal]);
  return (
    <>
      {!joiningLoading?activeModalId === rid && openModal ? (
        joinedRoom ? (
          setTradathonListingTab("live")
        ) : (
          <PublicContestModal
            d={dataForModal}
            onClose={closeModal}
            visible={openModal}
            winnings={winnings}
          />
        )
      ) : (
        <></>
      ):<></>}
      <div
        className={styles.Tradathon__LiveCard}
        style={{ cursor: "pointer" }}
        onClick={() => {
          closeModal();
          checkUserJoined(rid);
        }}
      >
        <div className={styles.Tradathon__LiveCard_children}>
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <p>Prize :{CalculatePrize(noOfPlayers,entryFees)}</p>
          )}
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <p style={{ color: "#717171" }}>
              {noOfPlayers - joinedMembers} left
            </p>
          )}
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <p style={{ color: "#E8BD6E" }}>{rtype}</p>
          )}
        </div>
        <div className={styles.Tradathon__LiveCard_children}>
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <div className="contestName">
              <b style={{ fontSize: "18px" }}>{rname}</b>
            </div>
          )}
          <img
            src={image}
            alt="bull/bear"
            className={styles.Tradathon__LiveCard_image}
          />
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "100%" }} />
          ) : (
            <div className={styles.progressholder}>
              <div
                className={styles.progressbar}
                style={{ width: `${(joinedMembers / noOfPlayers) * 100}%` }}
              ></div>
            </div>
          )}
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <>
              {rstatus === 0 ? (
                <Countdown date={startTime} renderer={renderer} />
              ) : (
                <Countdown date={endTime} renderer={renderer} />
              )}
              {/* <p style={{ color: "#E5646E" }}>
              {moment(startTime).format("MMMM Do YYYY, h:mm:ss a")}
            </p> */}
            </>
          )}
          {/* <button
                  className="TradathonRoom__join__button"
                  style={{
                    background: "rgba(69, 170, 67, 1)",
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    if (!tradathonLoading) {
                      joinRoom({
                        rcode: rcode,
                        pid: userData.profile_data._id,
                      });
                    }
                  }}
                >
                  &nbsp;JOIN&nbsp;
                </button> */}
        </div>
        <div className={styles.Tradathon__LiveCard_children}>
          {tradathonLoading ? (
            <>
              <div className="skeleton text" style={{ width: "150px" }} />
            </>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Badge
                name={rstatus === 0 ? "Upcoming" : "Live"}
                color={rstatus === 1 && "#45AA43"}
                setAnimation={rstatus === 1 ? true : false}
              />
              {rstatus === 0 && rtype !== "coin_storey_contest" && (
                <span
                  style={{ paddingLeft: "10px", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    history.push(`/tradathon/room/share?rcode=${rcode}`);
                  }}
                >
                  <BiShareAlt />
                </span>
              )}
            </div>
          )}
          {tradathonLoading ? (
            <>
              <div className="skeleton text" style={{ width: "150px" }} />
            </>
          ) : (
            <p>Entry Fee: {entryFees}</p>
          )}
          {tradathonLoading ? (
            <div className="skeleton text" style={{ width: "150px" }} />
          ) : (
            <p style={{ color: "#717171" }}>Max: {noOfPlayers}</p>
          )}
          {listingTab === "live" && (
            <>
              {tradathonLoading ? (
                <div className="skeleton text" style={{ width: "150px" }} />
              ) : (
                <p
                  style={{
                    color:
                      rstatus !== 0
                        ? isPaid
                          ? "#45AA43"
                          : "#e8bd6e"
                        : rstatus === 0
                        ? isPaid
                          ? "#45AA43"
                          : "rgb(233, 56, 72)"
                        : "#e8bd6e",
                  }}
                >
                  {rstatus !== 0
                    ? isPaid
                      ? "PAID"
                      : "SPECTATOR"
                    : rstatus === 0
                    ? isPaid
                      ? "PAID"
                      : "UNPAID"
                    : "SPECTATOR"}
                </p>
              )}
            </>
          )}
        </div>
        <div className={styles.mobile__view}>
          <div>
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <p>Prize :{prize}</p>
            )}
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <p style={{ color: "#717171" }}>
                {noOfPlayers - joinedMembers} left
              </p>
            )}
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <p style={{ color: "#E8BD6E" }}>{rtype}</p>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            {tradathonLoading ? (
              <>
                <div className="skeleton text" style={{ width: "150px" }} />
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <Badge
                  name={rstatus === 0 ? "Upcoming" : "Live"}
                  color={rstatus === 1 && "#45AA43"}
                  setAnimation={rstatus === 1 ? true : false}
                />
                {rstatus === 0 && (
                  <span
                    style={{ paddingLeft: "10px", cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(`/tradathon/room/share?rcode=${rcode}`);
                    }}
                  >
                    <BiShareAlt />
                  </span>
                )}
              </div>
            )}
            {tradathonLoading ? (
              <>
                <div className="skeleton text" style={{ width: "150px" }} />
              </>
            ) : (
              <p>Entry Fee: {entryFees}</p>
            )}
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <p style={{ color: "#717171" }}>Max: {noOfPlayers}</p>
            )}
            {listingTab === "live" && (
              <>
                
                {tradathonLoading ? (
                  <div className="skeleton text" style={{ width: "150px" }} />
                ) : (
                  <p
                    style={{
                      color:
                        rstatus !== 0
                          ? isPaid
                            ? "#45AA43"
                            : "#e8bd6e"
                          : rstatus === 0
                          ? isPaid
                            ? "#45AA43"
                            : "rgb(233, 56, 72)"
                          : "#e8bd6e",
                    }}
                  >
                    {rstatus !== 0
                      ? isPaid
                        ? "PAID"
                        : "SPECTATOR"
                      : rstatus === 0
                      ? isPaid
                        ? "PAID"
                        : "UNPAID"
                      : "SPECTATOR"}
                  </p>
                )}
              </>
            )}
          </div>
        </div>
        {tradathonLoading ? (
          <div className="shimmer-wrapper">
            <div className="shimmer"></div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default withRouter(LiveCard);
